import { ChangeDetectionStrategy, Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DataroomBrowserComponent } from '../dataroom-browser/dataroom-browser.component';
import { UserDataroomService } from '@core/dataroom/user-dataroom.service';
import { DataroomService } from '@core/dataroom/dataroom.service';
import { ClientDataroomService } from '@core/dataroom/client-dataroom.service';
import { TypedFormGroup } from '@feature/forms/form-model';

export interface MoveDialogData {
  id: string;
  service: DataroomService | UserDataroomService | ClientDataroomService;
}

export interface MoveDialogResult {
  id: string;
}

@Component({
    selector: 'wai-move-dialog',
    templateUrl: './move-dialog.component.html',
    styleUrls: ['./move-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MoveDialogComponent {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  @ViewChild('dataroomBrowser') public dataroomBrowser: DataroomBrowserComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: MoveDialogData,
    private dialogRef: MatDialogRef<MoveDialogComponent, MoveDialogData>,
  ) {}

  public submit(): void {
    this.dialogRef.close({
      id: this.dataroomBrowser.selectedNode.id,
      service: this.dialogData.service,
    });
  }
}
